export enum ShippingAddressTypeEnum {
  CUSTOM_ADDRESS = 'CUSTOM_ADDRESS',
  IMMEDIATE_TRANSFER = 'IMMEDIATE_TRANSFER',
  OFFICE = 'OFFICE',
  VENDING_MACHINE = 'VENDING_MACHINE',
  HANDOVER = 'HANDOVER',
}
